<!--
	TEMPLATE
-->
<template>
	<div class="md-grey-page">
		<div class="edit-page container margin-top-60" v-if="!applicantLoaded">
			<p class="loading-text">Loading applicant<span>.</span><span>.</span><span>.</span></p>
		</div>

		<div class="edit-page container" v-if="applicantLoaded">

		  <div class="mdc-layout-grid">
			<div class="mdc-layout-grid__inner edit-page__inner">
			  <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone">

					  <div class="edit-page__header edit-page__info mdc-layout-grid__cell--span-3">
							<h3 class="edit-page__applicant-title">{{ applicant.fullName }} <i v-if="applicant.emailConfirmed || applicant.mobileConfirmed" class="ico-checkmark applicants-list__checkmark"></i></h3>
							<div class="edit-page__header__info applicant-icons">
								<!--<i class="ico-piggy-bank"></i>-->
                <div v-if="applicant.ownerId">
                  <a href="javascript:;" @click.prevent="$router.push('/owners/'+applicant.ownerId)">
                    <i class="ico"><svg class="icon icon-user-tie"><use xlink:href="#icon-user-tie"></use></svg></i> <small>Owner </small>
                  </a>
                </div>
								<i class="ico-home"></i> {{getType(applicant.type)}}
								<i class="ico-bedroom"></i> {{applicant.bedrooms ? applicant.bedrooms : '--'}}<br>
                {{ applicant.budget ? formatCurrency(applicant.budget)+" "+(applicant.budget_type ? applicant.budget_type.toUpperCase() : '') : '--' }}<br>
							</div>
					  </div>

            <div class="mdc-layout-grid__cell--span-3 edit-page__make-owner">
              <a @click.prevent="makeOwner()" v-if="!applicant.ownerId || applicant.ownerId == ''">
                <i class="ico"><svg class="icon icon-user-tie"><use xlink:href="#icon-user-tie"></use></svg></i> <small>Make owner</small>
              </a>
            </div>
				</div>

				<div class="edit-page__content mdc-layout-grid__cell mdc-layout-grid__cell--span-8 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone">
					<!-- Fullname -->
					<editable-item component="editable-input" v-model="applicant.fullName" title="Full name" :options="{attentionSymbol: true}"
					@isEditView="editView(arguments[0])" @update="updateApplicant" @back="getApplicant" @hasErrors="errors('fullname', arguments[0])"></editable-item>

					<!-- Email -->
					<editable-item component="editable-input" v-model="applicant.email" title="Email" :options="{attentionSymbol: true}"
					@isEditView="editView(arguments[0])" @update="updateApplicant" @back="getApplicant" @hasErrors="errors('email', arguments[0])"></editable-item>

					<!-- Mobile -->
					<editable-item component="editable-input" v-model="applicant.mobile" title="Mobile" :options="{attentionSymbol: true}"
					@isEditView="editView(arguments[0])" @update="updateApplicant" @back="getApplicant" @hasErrors="errors('email', arguments[0])"></editable-item>

					<!-- Service type -->
					<editable-item component="editable-options" v-model="applicant.serviceType" title="Service Type" :options="{items: [[1, 'BUY'],[2, 'RENT']]}"
					@isEditView="editView(arguments[0])" @update="updateApplicant" @back="getApplicant"></editable-item>

					<!-- Bedrooms -->
					<editable-item component="editable-rooms" v-model="applicant.bedrooms" title="Bedrooms" :options="{items: [[0, 'Studio'],[1, '1 bedroom'],[2, '2 bedrooms'],[3, '3 bedrooms'],[4, '4 bedrooms'],[5, '5 bedrooms'],[6, '6 bedrooms'],[7, '7 bedrooms']]}"
					@isEditView="editView(arguments[0])" @update="updateApplicant" @back="getApplicant" @hasErrors="errors('bedrooms', arguments[0])"></editable-item>

					<!-- Property type -->
					<editable-item component="editable-options" v-model="applicant.type" title="Property Type" :options="{items: [['flat', 'Flat'],['house', 'House'],['either', 'Either']]}"
					@isEditView="editView(arguments[0])" @update="updateApplicant" @back="getApplicant" @hasErrors="errors('type', arguments[0])"></editable-item>

					<!-- Budget -->
					<editable-item component="editable-price" v-model="budgetObj" title="Budget"
					@isEditView="editView(arguments[0])" @update="updateApplicant" @back="getApplicant" :options="{serviceTypeId: applicant.serviceType, hideFrequencyDropdown: true}" @hasErrors="errors('budget', arguments[0])"></editable-item>

					<!-- Address -->
					<editable-item component="editable-address" v-model="address" title="Address" :options="{attentionSymbol: true}"
					@isEditView="editView(arguments[0])" @update="updateApplicant" @back="getApplicant" @hasErrors="errors('address', arguments[0])"></editable-item>

					<!-- Situation -->
					<editable-item v-if="applicant.serviceType == 1" component="editable-options" v-model="applicant.situation" title="Situation" :options="{items: [['renting', 'Renting'],['property-to-sell', 'Property to Sell'], ['buy-to-let-investor', 'Buy-to-let Investor'], ['developer', 'Developer'], ['other', 'Other']]}"
					@isEditView="editView(arguments[0])" @update="updateApplicant" @back="getApplicant" @hasErrors="errors('situation', arguments[0])"></editable-item>

					<editable-item v-if="applicant.serviceType == 2" component="editable-options" v-model="applicant.situation" title="Situation" :options="{items: [['urgently', 'Urgently'],['2-weeks', 'Within 2 weeks'], ['1-month', 'In one month'], ['1-3-months', 'In 1 to 3 months'], ['more-3-months', 'Not for at least 3 months']]}"
					@isEditView="editView(arguments[0])" @update="updateApplicant" @back="getApplicant" @hasErrors="errors('situation', arguments[0])"></editable-item>

					<!-- Property to sell -->
					<editable-item v-if="applicant.situation == 'property-to-sell'" component="editable-options" v-model="applicant.propertyToSell" title="Property to sell" :options="{items: [['on-market', 'On market'],['not-yet-on-market', 'Not yet on market'], ['sale-agreed', 'Sale agreed']]}"
					@isEditView="editView(arguments[0])" @update="updateApplicant" @back="getApplicant" @hasErrors="errors('situation', arguments[0])"></editable-item>

					<!-- Comments -->
					<editable-item component="editable-text" v-model="applicant.comments" title="Comments" :options="{rows: 10}"
					@isEditView="editView(arguments[0])" @update="updateApplicant" @back="getApplicant" @hasErrors="errors('long', arguments[0])"></editable-item>

					<!-- Availability -->
					<editable-item component="editable-options" v-model="applicant.availability" title="Availability" :options="{items: [['viewing', 'I\'m already viewing'],['ready', 'I\'m ready to view now'], ['browsing', 'I\'m just looking online for now']]}"
					@isEditView="editView(arguments[0])" @update="updateApplicant" @back="getApplicant" @hasErrors="errors('situation', arguments[0])"></editable-item>

          <!-- Availability -->
					<editable-item component="editable-options" v-model="applicant.signup_on" title="Lead Source" :options="{items: [['otm_feed', 'On The Market'], ['otm_feed_em', 'On The Market'], ['rm_feed', 'Rightmove'], ['rm_feed_em', 'Rightmove'], ['zoopla_feed', 'Zoopla'], ['zoopla_feed_em', 'Zoopla'], ['easymatch', 'Easymatch'], [['bestagent','mobile','linkedin','google','facebook','email'], 'BestAgent website'], ['own_website', 'Own website'], ['other', 'Other']]}"
					@isEditView="editView(arguments[0])" @update="updateApplicant" @back="getApplicant" @hasErrors="errors('situation', arguments[0])"></editable-item>

					<!-- Delete and Archive this property -->
					<div class="editable-item mdc-layout-grid__inner">
						<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 editable-item__title">
							<a href="#" class="edit-page__delete message--error" @click.prevent="deleteApplicant"><i class="ico ico-trash"></i>Delete this applicant</a>
						</div>
					</div>

					</div>
				</div>
			</div>

		</div>
</div>
</template>

<!--
	SCRIPT
-->
<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';
import EditableItem 	from '../components/editable-items/EditableItem.vue';

export default {
	data: function() {
		return {
			applicantLoaded: false,
			applicant: {},
			allErrors: {},
			budgetObj: {
				price: 0,
				rentFrequency: 'PCM',
				newPrice: 0
			},
			address: {
				number: '',
				flatNumber: '',
				street: '',
				postcode: '',
				town: '',
				county: '',
				lat: 0,
				lng: 0,
				addressNotEmpty: true
			}
		}
	},
	components: {
		'editable-item': EditableItem,
	},
	mixins: [utils],
	created: function() {
		// Get Applicant
		this.getApplicant();
	},
	computed: {
	},
	methods: {
    makeOwner: async function() {
      const makeowner = await api({endpoint: this.config.services.owners, path: `/fromapplicant/${this.applicant.companyId}/${this.applicant.applicantId}`, method: 'GET'});
      if (makeowner && typeof makeowner == 'string' && makeowner != '') {
        let reurl = makeowner.replace(/http(s)?\:\/\/[^\/]+/i,"");
        //console.log(reurl);
        //window.open(got, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        this.$router.push(reurl);
      }

    },
		getApplicant: async function() {
			this.applicant = await api({endpoint: this.config.services.applicants, path: '/' + this.$route.params.id, method: 'GET'});

			// Price obj
			this.budgetObj.price = this.applicant.budget;
			this.budgetObj.rentFrequency = 'PCM';
			this.budgetObj.newPrice = this.applicant.budget;

			// Address
			if(this.applicant.address == null) {
				this.applicant.address = this.address;
			} else {
				this.address = this.applicant.address;
			}
			if(!this.address.buildingNumber) {
				this.address.buildingNumber = '';
			}
			this.address.addressNotEmpty = true;

			this.applicantLoaded = true;
		},
		updateApplicant: async function() {
			if(this.anyErrors()) {
				alert('Please fill in the missing values in order to proceed!');
				return false;
			}

			// Address
			this.applicant.address.buildingNumber = this.address.buildingNumber ? this.address.buildingNumber : '';
			this.applicant.address.flatNumber = this.address.flatNumber ? this.address.flatNumber : '';
			this.applicant.address.street = this.address.street ? this.address.street.trim() : '';
			this.applicant.address.postcode = this.address.postcode ? this.address.postcode : '';
			this.applicant.address.town = this.address.town ? this.address.town.trim() : '';
			this.applicant.address.county = this.address.county ? this.address.county.trim() : '';
			this.applicant.address.latitude = this.address.latitude ? this.address.latitude : '';
			this.applicant.address.longitude = this.address.longitude ? this.address.longitude : '';

			// Price
			this.budgetObj.price = this.budgetObj.newPrice;
			this.applicant.budget = this.budgetObj.newPrice;

			var result = await api({endpoint: this.config.services.applicants, path: '/' + this.$route.params.id, method: 'PUT', body: this.applicant});
		},
		 deleteApplicant: async function() {
			 if(confirm('Are you sure you want to delete this applicant?')) {
				 try {
					 var result = await api({endpoint: this.config.services.applicants, path: '/' + this.$route.params.id, method: 'DELETE'});
					 this.$router.push('/applicants');
				 } catch(err) {
					 throw {
 						type: 'delete-applicant',
 						error: err
 					}
				 }
			 }
		},
		getType(type) {
			if(type == 'flat') {
				return 'Flat';
			} else if(type == 'house') {
				return 'House';
			} else if(type == 'either') {
				return 'Flat & House';
			} else {
				return '--';
			}
		},
		errors: function(item, hasErrors) {
			this.allErrors[item] = hasErrors;
		},
		anyErrors: function() {
			var self = this;
			return Object.keys(self.allErrors).reduce(function(acc, current) {
				if(self.allErrors[current]) {
					console.log('Found error: ', current);
				}
				return acc || self.allErrors[current];
			}, false);
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Applicants-Edit.vue